import axios from "axios";
// eslint-disable-next-line import/no-cycle
import { getCurrentIdToken, isSessionValid, signOut } from "pages/Auth/Cogcognito";
import { showError } from "utils/notifications";

const axiosInst = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInst.interceptors.request.use((config) => {
  const requestConfig = { ...config };
  requestConfig.headers.Authorization = getCurrentIdToken();
  return requestConfig;
});

axiosInst.interceptors.response.use(
  async (response) => response,
  async (error) => {
    console.log("interceptor:", error.response);

    // axios 0.27.x has a quirk: on network errors it sets error.response to the XHR
    // object (same value as error.request). Detect via error.code so we don't treat
    // that XHR as a real response.
    const isNetworkError =
      !error.response ||
      error.code === "ERR_NETWORK" ||
      error.code === "ECONNABORTED" ||
      error.code === "ETIMEDOUT" ||
      error.response === error.request;

    const status = isNetworkError ? undefined : error.response?.status;
    const data = isNetworkError ? undefined : error.response?.data;

    if (!isSessionValid()) {
      showError("Invalid session please sign in again!");
      await signOut();
      window.location.href = "/login";
    } else if (status === 401 || data?.message === "Unauthorized") {
      showError("Unauthorized!");
      await signOut();
      window.location.href = "/login";
    } else if (isNetworkError) {
      showError(error.message || "Network error");
    } else {
      const { error: errorMsg, message } = data || {};
      showError(errorMsg || message);
    }

    localStorage.setItem("apiFailCount", localStorage.getItem("apiFailCount") + 1);

    // Reject with the response on real HTTP errors, the AxiosError on network errors
    // (never the raw XHR - that's what causes [object XMLHttpRequest] in the React error overlay).
    return Promise.reject(isNetworkError ? error : error.response);
  },
);

export default axiosInst;
